import React, {useEffect, useState} from "react";
import {fetchDocument} from "../../Service/restapi/sharedContractService";
import PositionList from "./PositionList";


export default ({formSubmission, resourceId, documentId, values, handleChange, document}) => {
    const [currentDocument, setCurrentDocument] = useState(document);
    const [positions, setPositions] = useState(undefined);
    const [isSummable, setSummable] = useState(undefined);
    const [taxType, setTaxType] = useState(undefined);

    useEffect(() => {
        setCurrentDocument(document);
    }, [document]);

    useEffect(() => {
        fetchDocument(documentId).then(resp => {
            if (resp.ok) {
                resp.json().then(document => {
                    setCurrentDocument(document);
                    setPositions(document.positions);
                    setSummable(document.summable);
                    setTaxType(document.taxType);
                })
            } else {
                console.error("could not fetch positions of document " + documentId);
            }
        }).catch(error => {
            console.error("could not fetch positions of document " + documentId);
            console.error({error});
        });
    }, [documentId]);

    const handlePositionChange = (updatedPosition) => {
        setPositions(positions => positions.map(position => position.id === updatedPosition.id ? updatedPosition : position));
    };

    return <PositionList resourceId={resourceId} document={currentDocument || document} positions={positions} isSummable={isSummable} taxType={taxType} formSubmission={formSubmission} values={values} handleChange={handleChange} onPositionChange={handlePositionChange} />
}
